import _ from "@lodash";
import { Typography, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import React from "react";
import ImageGallery from "react-image-gallery";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Actions from "../../Arquivo/Store/Actions/ArquivoActions";
import { bindActionCreators } from "redux";
import { FuseAnimate } from "@fuse";
import Loading from "@fuse/components/FuseLoadable/Loading";

const styles = () => ({
    image: {
        "& img": {
            maxHeight: "65vh !important"
        },
    },
    gallery: {
        "& .image-gallery-slides": {
            minHeight: 400
        }
    }
});

class Visualizacao03 extends XAPPComponent {

    getImages = () => {
        const { Arquivo, classes, xappRouteParams, user } = this.props;
        let AResponse = [];
        if (!_.isNull(Arquivo.data)) {
            Arquivo.data.forEach(item => {
                AResponse.push({
                    original: `${document.location.origin}/api/arquivo/image/${xappRouteParams.empresa}/${item.idarquivo}?tk=${sessionStorage.getItem("jwt_access_token")}`,
                    originalTitle: item.descricao,
                    originalClass: classes.image,
                    loading: "lazy"
                });
            });
        }
        return AResponse;
    };

    render() {
        const { Arquivo, preload, classes } = this.props;
        let AImages = this.getImages();
        return (
            <React.Fragment>
                {preload ?
                    <div className="xs:py-56 sm:py-128">
                        <Loading pastDelay={true} />
                    </div>
                    :
                    <React.Fragment>
                        {AImages.length > 0 ?
                            <React.Fragment>
                                {AImages.length < Arquivo.data.length &&
                                    <Typography variant="h5" color="textSecondary" className="text-center my-4">
                                        {`Carregando imagens ${AImages.length} de ${Arquivo.data.length}...`}
                                    </Typography>
                                }
                                <ImageGallery
                                    items={AImages}
                                    lazyLoad={true}
                                    showThumbnails={false}
                                    additionalClass={classes.gallery}
                                />
                            </React.Fragment>
                            :
                            <div className="flex flex-col flex-1 items-center justify-center p-48">
                                <div className="max-w-512 text-center">
                                    <FuseAnimate delay={500}>
                                        <Typography variant="h6" color="textSecondary" className="mb-16">
                                            {"Não existem registros cadastrados!"}
                                        </Typography>
                                    </FuseAnimate>
                                </div>
                            </div>
                        }
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getImage: Actions.getImage,
    }, dispatch);
}

function mapStateToProps({ Arquivo, auth }) {
    return {
        Arquivo: Arquivo,
        preload: Arquivo.preload,
        user: auth.user
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Visualizacao03)));